// prettier-ignore
export default "Macchine/Xerox Ciano FR"